__turbopack_context__.v({
  "content": "heroBackdrop-module__YGoWRW__content",
  "pullUnderNavbar": "heroBackdrop-module__YGoWRW__pullUnderNavbar",
  "root": "heroBackdrop-module__YGoWRW__root",
});
